import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/",
)({
  loader({ params }) {
    throw redirect({
      to: "/athletes/$athleteId/questionnaires/$questionnaireId/submissions",
      params: {
        athleteId: params.athleteId,
        questionnaireId: params.questionnaireId,
      },
    });
  },
});
